import React, { useEffect, useState } from "react";
import { Avatar } from "@/types/interfaces";
import TextInputModal from "../TextInputModal";
import { NumberField, seedDigits } from "../TextInputModal/fields";

interface AgeModalProps {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  newAvatar: Avatar;
  handlePickerChange: (key: string, value: object) => void;
}

// Mirrors the wheel picker's range (13–100).
const AGE_MIN = 13;
const AGE_MAX = 100;

const AgeModal: React.FC<AgeModalProps> = ({
  open,
  onClose,
  onCancel,
  newAvatar,
  handlePickerChange,
}) => {
  const [age, setAge] = useState("");

  useEffect(() => {
    if (!open) return;
    const seed = seedDigits(newAvatar.age);
    setAge(seed);
    // Re-sync the draft the parent commits from. This modal seeds off the
    // committed `age` but closeAgeModal commits `agePicker`, so the two diverge
    // after a cancel and Ok would then commit the cancelled value. The wheel
    // picker kept them in step implicitly, via its mount-time onChange.
    handlePickerChange("agePicker", { agePicker: seed });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const validate = () => {
    const n = parseInt(age, 10);
    if (!age || n < AGE_MIN || n > AGE_MAX) return "Invalid age input";
    return null;
  };

  return (
    <TextInputModal
      open={open}
      onCancel={onCancel}
      onClose={onClose} // parent's closeAgeModal (reads newAvatar.agePicker)
      title="Enter age"
      validate={validate}
    >
      {({ hasError, clearError, submit }) => (
        <NumberField
          value={age}
          hasError={hasError}
          ariaLabel="Age"
          onSubmit={submit}
          onChange={(digits) => {
            setAge(digits);
            // same key closeAgeModal reads (agePicker → age)
            handlePickerChange("agePicker", { agePicker: digits });
            clearError();
          }}
        />
      )}
    </TextInputModal>
  );
};

export default AgeModal;
